/// <reference path="../../PropertyManagement/Tenants/TenantsGrid.ts" />

namespace SorAraBul.PropertyManagement {

    import fld = TenantsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class PropertyTenantsGrid extends TenantsGrid {
        protected getDialogType() { return PropertyTenantsDialog; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getColumns() {
            var columns = super.getColumns()
                .filter(x => x.field !== fld.PropertyId)
                .filter(x => x.field !== fld.PropertyFullName);

            return columns;
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        protected addButtonClick() {
            this.checkCreditAndContinue(() => this.editItem({ PropertyId: this.propertyId }));
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.propertyId;
        }

        private _propertyId: number;

        get propertyId() {
            return this._propertyId;
        }

        set propertyId(value: number) {
            if (this._propertyId !== value) {
                this._propertyId = value;
                this.setEquality('PropertyId', value);
                this.refresh();
            }
        }
    }
}
